import React, { useContext, useState } from "react";

import {
  FaBars,
  FaCcDinersClub,
  FaUserLock,
  FaCuttlefish,
  FaUserTie,
  FaUsers,
  FaStore,
} from "react-icons/fa";
import { FaClipboardUser } from "react-icons/fa6";
import {
  TbRecharging,
  TbCricket,
  TbPlayFootball,
  TbReportAnalytics,
  TbAlignBoxBottomCenterFilled,
} from "react-icons/tb";
import {
  AiFillDashboard,
  AiOutlineWallet,
  AiOutlineTransaction,
  AiOutlineDribbble,
} from "react-icons/ai";
import { GiHound, GiRingmaster } from "react-icons/gi";
import { GrTransaction } from "react-icons/gr";
import { CgGames } from "react-icons/cg";
import { FcSportsMode, FcCurrencyExchange } from "react-icons/fc";
import { PiNewspaperClippingThin } from "react-icons/pi";
import {
  MdSportsKabaddi,
  MdSportsTennis,
  MdSportsHockey,
  MdDashboard,
  MdCasino,
  MdAccountBox,
  MdSupportAgent,
  MdHistoryEdu,
} from "react-icons/md";
import { Navigate, useNavigate } from "react-router-dom";
import { NavLink } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import NavDropdown from "react-bootstrap/NavDropdown";
import SidebarLink from "./sidebar-link";
import { Container, Navbar } from "react-bootstrap";
import {
  checkUserAccess,
  isAuthenticated,
  logoutUser,
} from "../../network/service/UserService";

import AppLogo from "../../assets/logotransparant.png";
import AppToast from "../../components/appToast";

let selctedMenu;
const Sidebar = ({ children }) => {
  let addressUrl = new URL(window.location.href);
  let pathName = addressUrl.pathname.split("/");
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [subnav, setSubnav] = useState(false);
  const [activeMenu, setActiveMenu] = useState("");
  const [subnavIndex, setSubnavIndex] = useState();

  const toggle = () => setIsOpen(!isOpen);
  const showSubNav = (mainIndex) => {
    setSubnav(!subnav);
    setSubnavIndex(mainIndex);
  };

  const logout = async () => {
    await localStorage.setItem("authToken", "");
    await logoutUser();
    navigate("/login");
  };

  const menuItem = [
    {
      path: "/dashboard",
      name: "Dashboard",
      icon: <MdDashboard />,
      subnav: [],
      roles: ["1", "2", "3", "4"],
    },
    {
      path: "/banners",
      name: "Banners",
      icon: <MdDashboard />,
      subnav: [],
      roles: ["1", "2", "3", "4"],
    },
    {
      path: "",
      name: "Products Util",
      icon: <FaUserTie />,
      subnav: [
        {
          path: "/categories",
          name: "Categories",
          icon: <FaUserTie />,
          subnav: [],
          roles: ["1", "2", "3", "4"],
        },
        {
          path: "/subcategories",
          name: "Sub Categories",
          icon: <FaUserTie />,
          subnav: [],
          roles: ["1", "2", "3", "4"],
        },
        {
          path: "/uom",
          name: "Unit Of Measure",
          icon: <FaUserTie />,
          subnav: [],
          roles: ["1", "2", "3", "4"],
        },

        {
          path: "/brands",
          name: "Brands",
          icon: <FaUserTie />,
          subnav: [],
          roles: ["1", "2", "3", "4"],
        },
        {
          path: "/tags",
          name: "Tags",
          icon: <FaUserTie />,
          subnav: [],
          roles: ["1", "2", "3", "4"],
        },
        {
          path: "/taxSlabs",
          name: "Tax Slabs",
          icon: <FaUserTie />,
          subnav: [],
          roles: ["1", "2", "3", "4"],
        },

        {
          path: "/hsn",
          name: "HSN Codes",
          icon: <FaUserTie />,
          subnav: [],
          roles: ["1", "2", "3", "4"],
        },
        {
          path: "/colors",
          name: "Colors",
          icon: <FaUserTie />,
          subnav: [],
          roles: ["1", "2", "3", "4"],
        },
        {
          path: "/mtypes",
          name: "Material Types",
          icon: <FaUserTie />,
          subnav: [],
          roles: ["1", "2", "3", "4"],
        },
      ],
      roles: ["1", "2", "3", "4"],
    },
    {
      path: "/products",
      name: "Products",
      icon: <FaUserTie />,
      subnav: [],
      roles: ["1", "2", "3", "4"],
    },

    {
      path: "",
      name: "Orders",
      icon: <FcSportsMode />,
      subnav: [
        {
          path: "/porders",
          name: "Orders",
          icon: <MdCasino />,
          subnav: [],
          roles: ["1", "2", "3", "4"],
        },
        {
          path: "/corder",
          name: "Create Order",
          icon: <MdCasino />,
          subnav: [],
          roles: ["1", "2", "3", "4"],
        },
      ],
      roles: ["1", "2", "3", "4"],
    },
    {
      path: "",
      name: "Users",
      icon: <FaUserTie />,
      subnav: [
        {
          path: "/admin",
          name: "Admin",
          icon: <FaUsers />,
          subnav: [],
          roles: ["1", "2", "3", "4"],
        },
        {
          path: "/appusers",
          name: "App Users",
          icon: <FaUsers />,
          subnav: [],
          roles: ["1", "2", "3", "4"],
        },
        {
          path: "/storeusers",
          name: "Store Users",
          icon: <FaUsers />,
          subnav: [],
          roles: ["1", "2", "3", "4"],
        },
        {
          path: "/deliveryboys",
          name: "Delivery Boys",
          icon: <FaUsers />,
          subnav: [],
          roles: ["1", "2", "3", "4"],
        },
      ],
      roles: ["1", "2", "3", "4"],
    },
    {
      path: "/stores",
      name: "Branches",
      icon: <FaStore />,
      subnav: [],
      roles: ["1"],
    },
    {
      path: "",
      name: "Reports",
      icon: <FaCcDinersClub />,
      subnav: [
        {
          path: "/dreports",
          name: "Daily Report",
          icon: <FaCcDinersClub />,
          subnav: [],
          roles: ["1", "2", "3", "4"],
        },
        {
          path: "/wreports",
          name: "Weekly Reports",
          icon: <FaCcDinersClub />,
          subnav: [],
          roles: ["1", "2", "3", "4"],
        },
        {
          path: "mreports",
          name: "Monthly Reports",
          icon: <FaCcDinersClub />,
          subnav: [],
          roles: ["1", "2", "3", "4"],
        },
        {
          path: "yreports",
          name: "Yearly Reports",
          icon: <FaCcDinersClub />,
          subnav: [],
          roles: ["1", "2", "3", "4"],
        },
        {
          path: "creports",
          name: "Custom Report",
          icon: <FaCcDinersClub />,
          subnav: [],
          roles: ["1", "2", "3", "4"],
        },
      ],
      roles: ["1", "2", "3", "4"],
    },
  ];

  return (
    <>
      {pathName[1] !== "login" && isAuthenticated() ? (
        <div className="sidenav-layout">
          <div
            style={{ width: isOpen ? "60px" : "200px", transition: "all 0.5s" }}
            className="sidebar"
          >
            <div className="top_section">
              {/* <img
                style={{
                  display: isOpen ? "none" : "block",
                  height: 35,
                }}
                className="logo"
                src=""
              /> */}

              <p
                style={{
                  display: isOpen ? "none" : "block",
                  padding: "10px",
                  color: "#FFFFFF",
                }}
              >
                B2B
              </p>
              <div
                style={{ marginLeft: isOpen ? "0px" : "50px" }}
                className="bars"
              >
                <FaBars onClick={toggle} />
              </div>
            </div>
            <div className="mnu">
              {menuItem.map(
                (item, menuIndex) =>
                  // <SidebarLink item={item} isMenuExpand={isOpen} />
                  checkUserAccess(item.roles) && (
                    <SidebarLink
                      key={menuIndex}
                      item={item}
                      isMenuExpand={isOpen}
                      activeMenu={activeMenu}
                      selectedMenu={(menu) => {
                        setActiveMenu(menu);
                      }}
                    />
                  )
              )}
            </div>
          </div>

          <div
            className="dsply-desktp"
            style={{
              position: "Fixed",
              width: "100%",
              zIndex: 9,
              // marginLeft: isOpen ? "200px" : "60px"
            }}
          >
            <Navbar collapseOnSelect expand="lg">
              <div className="container-fluid">
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse id="responsive-navbar-nav">
                  <Nav className="me-auto">
                    <img
                      src={AppLogo}
                      alt="Biyss"
                      style={{ height: 50, width: 160, marginLeft: 220 }}
                    />
                  </Nav>
                  <Nav className="me-auto"></Nav>
                  <Nav>
                    <NavDropdown
                      title={
                        <img
                          style={{ height: 30, width: 28 }}
                          className="logo"
                          src="https://cdn.icon-icons.com/icons2/1919/PNG/512/avatarinsideacircle_122011.png"
                        />
                      }
                      id="collasible-nav-dropdown"
                    >
                      <NavDropdown.Item
                        onClick={() => navigate("/changepassword")}
                      >
                        Change Password
                      </NavDropdown.Item>
                      <NavDropdown.Item onClick={() => logout()}>
                        Logout
                      </NavDropdown.Item>
                    </NavDropdown>
                  </Nav>
                </Navbar.Collapse>
              </div>
            </Navbar>
          </div>

          <div className="mble-dsply mble-dsply1">
            <div
              className="mnu"
              style={{ marginLeft: isMobileMenuOpen ? "0px" : "-100%" }}
            >
              {menuItem.map(
                (item, menuIndex) =>
                  // <SidebarLink item={item} isMenuExpand={isOpen} />
                  checkUserAccess(item.roles) && (
                    <SidebarLink
                      key={menuIndex}
                      item={item}
                      isMenuExpand={isOpen}
                      activeMenu={activeMenu}
                      selectedMenu={(menu) => {
                        setActiveMenu(menu);
                        setIsMobileMenuOpen(false);
                      }}
                    />
                  )
              )}
            </div>
            <div className="row p-1">
              <div className="col-4 mt-2 mb-1">
                <div
                  className="mobile-menu-toggle"
                  onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                >
                  <FaBars />
                </div>
              </div>
              <div className="col-6 mt-3">
                <img
                  style={{ width: 140, marginLeft: -20 }}
                  className="logo"
                  src=""
                  onClick={() => navigate("/dashboard")}
                />
              </div>
              <div className="col-2 mt-3">
                <NavDropdown
                  title={
                    <img
                      style={{ height: 30, width: 28 }}
                      className="logo"
                      src="https://cdn.icon-icons.com/icons2/1919/PNG/512/avatarinsideacircle_122011.png"
                    />
                  }
                  id="collasible-nav-dropdown"
                >
                  <NavDropdown.Item onClick={() => navigate("/changepassword")}>
                    Change Password
                  </NavDropdown.Item>
                  <NavDropdown.Item onClick={() => logout()}>
                    Logout
                  </NavDropdown.Item>
                </NavDropdown>
              </div>
            </div>
          </div>

          <main
            className="main-layout"
            style={{
              marginLeft: isOpen ? "60px" : "200px",
            }}
          >
            {/* <div className="mble-dsply">
              <div className="row mt-3">
                <div className="col-6">
                  <label>Main Balance: </label>
                </div>
              </div>
            </div> */}

            <div>{children}</div>
          </main>
        </div>
      ) : (
        <div>{children}</div>
      )}
    </>
  );
};

export default Sidebar;
